import './LoadingCircle.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class LoadingCircle extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        innerColor: PropTypes.string,
        outerColor: PropTypes.string
    };

    render() {
        return (
            <div className={`c-loading-circle ${this.props.className || ''}`}>
                <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle className="c-loading-circle__outer" cx="50" cy="50" r="40" stroke={this.props.outerColor || '#404969'} transform="rotate(152.5 50 50)">
                        <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="2.4s" begin="0s" repeatCount="indefinite"></animateTransform>
                    </circle>
                    <circle className="c-loading-circle__inner" cx="50" cy="50" r="30" stroke={this.props.innerColor || '#ff6850'}  transform="rotate(-152.5 50 50)">
                        <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;-360 50 50" keyTimes="0;1" dur="2.4s" begin="0s" repeatCount="indefinite"></animateTransform>
                    </circle>
                </svg>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/LoadingCircle/index.js